<template>
  <b-container class="p-3 pt-5" fluid>
    <b-row class="justify-content-center">
      <b-col md="auto" class="role-column">
        <div class="text-center mb-4">
          <h1>เลือกระดับสิทธิ์ที่ต้องการใช้งาน</h1>
          <p class="mb-0">เนื่องจากบัญชีผู้ใช้นี้ มีสิทธิ์การใช้งานมากกว่า 1 สิทธิ์หรือมากกว่า 1 หน่วยงาน กรุณาเลือกสิทธิ์ที่ต้องการใช้งานเพื่อดำเนินการต่อ</p>
          <p class="text-muted">คุณสามารถสลับสิทธิ์การใช้งานได้ตลอดเวลา โดยคลิกที่เมนูบริเวณมุมบนด้านขวาและเลือก "สลับสิทธิ์การใช้งาน"</p>
        </div>

        <b-list-group class="role-list">
          <b-list-group-item
            v-for="role in roles"
            :key="role._id"
            button
            :active="selectedRoleId === role._id"
            :disabled="isBusy"
            @click="setRoleId(role._id)"
          >
            <div class="role">
              <template v-if="role.role === 'coordinator'">ผู้ประสานงาน</template>
              <template v-else-if="role.role === 'hog'">
                <span v-if="role.head_of_group.type === 7">เจ้าหน้าที่</span><span v-else>ประธาน</span>{{ ROLE_SUFFIX_BY_GROUP_TYPE_CODE[role.head_of_group.type] }}
              </template>
              <template v-else-if="role.role === 'advisor'">ที่ปรึกษา{{ ROLE_SUFFIX_BY_GROUP_TYPE_CODE[role.advisor_of_group.type] }}</template>
              <template v-else-if="role.role === 'faculty_staff'">เจ้าหน้าที่กิจการนักศึกษาคณะ</template>
              <template v-else-if="role.role === 'faculty_dean'">รอง/ผู้ช่วยคณบดี</template>
            </div>

            <span v-if="role.role === 'coordinator'">ทุกหน่วยงาน</span>
            <span v-else-if="role.role === 'hog'">{{ role.head_of_group.name }}</span>
            <span v-else-if="role.role === 'advisor'">{{ role.advisor_of_group.name }}</span>
            <span v-else-if="role.role === 'faculty_staff'">{{ role.faculty.name }}</span>
            <span v-else-if="role.role === 'faculty_dean'">{{ role.faculty.name }}</span>
          </b-list-group-item>
        </b-list-group>

        <form ref="eventForm" action="https://event.osda.kmitl.ac.th/sso" method="POST" target="_blank">
          <input type="hidden" name="token" :value="$auth.token()">
        </form>

        <b-list-group class="role-list mt-5">
          <b-list-group-item button @click="$refs.eventForm.submit()">
            <div class="role">ระบบลงทะเบียนกิจกรรมออนไลน์</div>
            <span>จัดการการลงทะเบียนเข้าร่วมกิจกรรมออนไลน์ของกิจกรรมที่ผ่านการอนุมัติแล้ว</span>
          </b-list-group-item>
        </b-list-group>

        <div class="text-center mt-3">
          <b-button
            variant="warning"
            :disabled="isBusy"
            @click="switchRole"
          >
            <template v-if="!isBusy">
              ดำเนินการต่อ <font-awesome-icon icon="arrow-right" class="mr-0 ml-1" size="sm" />
            </template>
            <template v-else>
              <inline-loading />
            </template>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ROLE_COORDINATOR, ROLE_HEAD_OF_GROUP, ROLE_ADVISOR, ROLE_SUFFIX_BY_GROUP_TYPE_CODE } from '@/constants'

export default {
  data: () => ({
    ROLE_COORDINATOR,
    ROLE_HEAD_OF_GROUP,
    ROLE_ADVISOR,
    ROLE_SUFFIX_BY_GROUP_TYPE_CODE,
    isBusy: false,
    selectedRoleId: null
  }),
  computed: {
    roles () {
      let isCoordinatorFound = false
      return this.$auth.user().roles.filter(role => {
        if (role.role === 'coordinator' && isCoordinatorFound) {
          return false
        }

        if (role.role === 'coordinator' && !isCoordinatorFound) {
          isCoordinatorFound = true
        }

        return role
      })
    }
  },
  beforeCreate () {
    if (this.$auth.user().role === 'osda') {
      this.$router.replace('projects')
    }
  },
  created () {
    this.selectedRoleId = this.$auth.user().currentRoleId
  },
  methods: {
    setRoleId (roleId) {
      this.selectedRoleId = roleId
    },
    async switchRole () {
      this.isBusy = true

      try {
        await this.$store.dispatch('user/switchRole', this.selectedRoleId)
        await this.$auth.fetch()

        this.$root.$bvToast.toast('สลับสิทธิ์การใช้งานสำเร็จ', {
          title: 'แจ้งเตือน',
          variant: 'success',
          solid: true,
          noCloseButton: false
        })

        this.$router.push({ name: 'projects.index' })
      } catch (error) {
        this.$bvToast.toast('พบข้อผิดพลาดในการสลับสิทธิ์การใช้งาน', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true,
          noCloseButton: false
        })
        this.isBusy = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.5rem;
}

.role-column {
  min-width: 40%;
}

.role {
  font-size: 1.1rem;
  font-weight: bold;
}
</style>
